module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/c45JFN/tc-custom/9781488083877.jpg?1741148247727",
      "alt": "This image is the cover for the book Tycoon's Ultimate Conquest"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tycoon's Ultimate Conquest\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("His plan is simple…  The ultimate seduction!  When lawyer Rose Tremain places Arturo da Costa’s latest business deal in jeopardy, the billionaire plans to challenge her in the boardroom. Yet when he meets spirited Rose, the sizzling connection between them is irresistible! Now seduction is his greatest asset. He’ll ensure Rose is so overwhelmed with pleasure she forgets all about the deal. Until he finds himself equally addicted—to her!  “An utterly enjoyable enemy to lovers story…the chemistry between this couple is charming.” —Harlequin Junkie on Legacy of His Revenge  “I absolutely adored this story. The writing was descriptive without being over the top and the characters were in typical Harlequin fashion, perfect. A great read!” —Goodreads Reader on Cipriani’s Innocent Captive")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cathy Williams\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Cathy Williams is a great believer in the power of perseverance as she had never written anything before her writing career, and from the starting point of zero has now fulfilled her ambition to pursue this most enjoyable of careers. She would encourage any would-be writer to have faith and go for it! She derives inspiration from the tropical island of Trinidad and from the peaceful countryside of middle England. Cathy lives in Warwickshire her family.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0